import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Divider,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Backdrop,
  CircularProgress,
  Select
} from '@material-ui/core';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker from '@material-ui/lab/DatePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { baseUrl } from '../../../utils/constants';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import { useClientContext } from '../../../context/client_context';
import { ClientListHead } from '../../_dashboard/clients';
import Controls from '../../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'claimNo', label: 'Claim #', alignRight: false },
  { id: 'membershipNo', label: 'Member #', alignRight: false },
  { id: 'surname', label: 'Surname', alignRight: true },
  { id: 'firstName', label: 'First Name', alignRight: true },
  { id: 'principalMember', label: 'Principal ', alignRight: false },
  { id: 'age', label: 'Age', alignRight: false },
  { id: 'scheme', label: 'Scheme', alignRight: false },
  { id: 'treatmentDate', label: 'Treatment Date', alignRight: false },
  { id: 'tarrifCode', label: 'Tarif Code', alignRight: false },
  { id: 'amount', label: 'Amount Claimed', alignRight: true },
  { id: 'amountPd', label: 'Amount Paid', alignRight: true },
  { id: 'provider', label: 'Provider', alignRight: false },
  { id: 'department', label: 'Department', alignRight: true },
  { id: 'service', label: 'Service', alignRight: true }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClaimsProvider() {
  const {
    setClientRefId,
    refreshClientValues,
    setCustomerIdentifier,
    getNextOutstandingEntity,
    getCustomerLogin,
    getCustomerRequirementsView
  } = useClientContext();
  const m = moment();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [begDate, setBegDate] = useState(m.subtract(30, 'd'));
  const [endDate, setEndDate] = useState(new Date());
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [namas, setNamas] = useState('');
  const [provider, setProvider] = useState(0);
  const [docType, setDocType] = useState('pdf');
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });

  const filename = `ClaimsProvider_${provider}_${moment().format('DD-MMM-YYYY')}.${docType}`;
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    // getProviderClaims();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClientView = (client) => {
    console.log('row data  client is', client);
    setCustomerIdentifier(client.atlasId);
    setClientRefId(client.refId);
    getCustomerLogin(client.atlasId);
    getCustomerRequirementsView(client.atlasId);
    refreshClientValues(client.atlasId);
    openView();
  };

  const openView = () => {
    navigate('/clientportfolio/portfolio');
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  const getProviderClaims = () => {
    if (namas === '') {
      notifyPopup(`No Provider # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    fetch(
      `${baseUrl}/api/client/getProviderClaims?from=${moment(begDate).format(
        'YYYY-MM-DD'
      )}&to=${moment(endDate).format('YYYY-MM-DD')}&dataType=1&namasNo=${namas}`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned Provider getProviderClaims Summary list', result);
          setDataList(result.result);
        },
        (error) => {
          notifyPopup(`Error in rovider getProviderClaims Summary!: ${error}`, 'error');
        }
      );
    setLoading(false);
  };

  const downloadDocument = () => {
    if (namas === '') {
      notifyPopup(`No Provider # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    fetch(
      `${baseUrl}/api/report/get/ClaimByProvider/${docType}/${moment(begDate).format(
        'YYYY-MM-DD'
      )}/${moment(endDate).format('YYYY-MM-DD')}/${namas}/1/0/0/0`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Downloading Claims by Provider!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={5} sm={3}>
          <Typography component="span" variant="h4" gutterBottom>
            Claims by Provider
          </Typography>
        </Grid>
        {/* <Grid item xs={12} sm={1}>
          <FormControl fullWidth>
            <TextField
              value={provider}
              onChange={(e) => {
                setProvider(e.target.value);
              }}
              color="primary"
              label="Provider #"
              placeholder="Provider #"
              size="small"
              variant="standard"
            />
          </FormControl>
        </Grid> */}
        <Grid item xs={12} sm={1}>
          <FormControl fullWidth>
            <TextField
              value={namas}
              onChange={(e) => {
                setNamas(e.target.value);
              }}
              color="primary"
              label="AHFOZ No."
              placeholder="AHFOZ No"
              size="small"
              variant="standard"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={1}>
          <FormControl className={classes.formControl}>
            <InputLabel id="selectDoc">Doc Type</InputLabel>
            <Select
              labelId="selectDoclabel"
              id="docType"
              value={docType}
              size="small"
              onChange={(e) => {
                setDocType(e.target.value);
              }}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="xls">XLS</MenuItem>
              <MenuItem value="doc">WORD</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Start Date"
              inputFormat="dd/MM/yyyy"
              value={begDate}
              onChange={(e) => {
                setBegDate(e);
              }}
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="End Date"
              inputFormat="dd/MM/yyyy"
              value={endDate}
              onChange={(e) => {
                setEndDate(e);
              }}
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => getProviderClaims()}
          >
            Refresh
          </Button>
        </Grid>
        <Grid item xs={12} sm={1} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => downloadDocument()}
          >
            Download
          </Button>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, margin: 10 }} variant="middle" />

      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      accoountRef,
                      amtClaimed,
                      amtPaid,
                      batchNumber,
                      claimNUmber,
                      claim_Status,
                      clearanceRequest,
                      currentAge,
                      debit,
                      department,
                      error_id,
                      firstName,
                      groupCode,
                      idnumber,
                      memberShipNo,
                      noOfVisits,
                      otherdiagnosis,
                      principalMember,
                      provider,
                      receivedOn,
                      refundedOn,
                      runno,
                      scheme,
                      schemestartdate,
                      service,
                      suffix,
                      surname,
                      tarif_code,
                      treatmentDate
                    } = row;
                    const isItemSelected = selected.indexOf(claimNUmber) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={claimNUmber}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />

                        <TableCell align="right">{claimNUmber}</TableCell>
                        <TableCell align="right">{memberShipNo}</TableCell>
                        <TableCell align="left">{surname}</TableCell>
                        <TableCell align="left">{firstName}</TableCell>
                        <TableCell align="left">{principalMember}</TableCell>
                        <TableCell align="left">{currentAge}</TableCell>
                        <TableCell align="left">{scheme}</TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {moment(treatmentDate).isValid()
                            ? moment(treatmentDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="left">{tarif_code}</TableCell>
                        <TableCell align="right">{amtClaimed.toFixed(2)}</TableCell>
                        <TableCell align="right">{amtPaid.toFixed(2)}</TableCell>
                        <TableCell align="left">{provider}</TableCell>
                        <TableCell align="left">{department}</TableCell>
                        <TableCell align="left">{service}</TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isListEmpty && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
